import axios from 'axios';
import { IResponse } from '~/services/api/types';
import {
  IIcd10Code,
  IIcd10CodeList,
  IIcd10CodesBulkCreateDto,
  IIcd10CodesFilters,
  IIcd10CodesSelectors,
} from './types';

const apiUrl = 'icd-10-codes';

export const getList = (params: IIcd10CodesFilters): IResponse<IIcd10CodeList[]> =>
  axios({
    method: 'get',
    url: apiUrl,
    params,
  });

export const getById = (id: number): IResponse<IIcd10Code> =>
  axios({
    method: 'get',
    url: `${apiUrl}/${id}`,
  });

export const getSelectors = (): IResponse<IIcd10CodesSelectors> =>
  axios({
    method: 'get',
    url: `${apiUrl}/selectors`,
  });

export const createBulk = (data: IIcd10CodesBulkCreateDto): IResponse<IIcd10CodeList[]> =>
  axios({
    method: 'post',
    url: `${apiUrl}/bulk`,
    data,
  });

export const update = (data: IIcd10Code): IResponse<IIcd10CodeList> =>
  axios({
    method: 'put',
    url: apiUrl,
    data,
  });

export const remove = (id: number): IResponse<void> =>
  axios({
    method: 'delete',
    url: `${apiUrl}/${id}`,
  });

export default {};
